import { useEffect, useState } from "react";
import { HTTPURL, REQUEST_OPTIONS, REQUEST_OPTIONS_NO_HEAD } from "../../constants/matcher";

const Dashboard = () => {
  const [mentors, setMontors] = useState([]);
  useEffect(() => {
    // mentors 1, servants 0
    const token = JSON.parse(localStorage.getItem("user-token"));
    const mentors = async () => {
      return await fetch(HTTPURL + 'user/get-all-user-list/1', { headers: { "Authorization": `Bearer ${token}` } })
        .then((res) => res.json())
        .then((data) => setMontors(data.data));
    }
    mentors();
  }, []);

  return (
    <main>
      <div className="container-fluid px-4">
        <h1 className="mt-4">Welcome Adedayo Omoboboye</h1>
        <ol className="breadcrumb mb-4">
          <li className="breadcrumb-item active">Your Progress</li>
        </ol>

        <div className="row">
          <div className="col-xl-8">
            <div className="card mb-4">
              <div className="card-header">
                <i className="fas fa-chart-area me-1"></i>
                Available Mentors &nbsp;&nbsp;&nbsp;&nbsp;
                <label>View More</label>
              </div>
              <div className="card-body">
                <div className="row">
                  {
                    mentors && mentors.map((mentor, index) => {
                      return (
                        <div className="col-md-4 mb-4" key={index}>
                          <div className="card">
                            <img src={HTTPURL + 'images/' + mentor.photo} className="card-img-top" alt="..." />
                            <div className="card-body">
                              <h5 className="card-title">{mentor.firstName + ' ' + mentor.lastName}</h5>
                              <i className="fas fa-map-marker-alt"></i><a href="#" className="btn">
                                {mentor.state != "undefined" ? mentor.state : ''}</a>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4">
            <div className="card mb-4">
              <div className="card-header">
                <i className="fas fa-chart-bar me-1"></i>
                Activity
              </div>
              <div className="card-body">

              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
};

export default Dashboard;